var globalFunctions = require('./globalFunctions.js');

module.exports = {
  haderHtml: function () {
       let html = '<div class="games-table-header-holder">'+
                    '<div class="games-table-header games-table-title-long">'+
                        'EVENTS'+
                    '</div> '+
                   ' <div class="games-table-header games-table-tree">'+
                        '<ul>'+
                            '<li>1X&NG</li> '+
                            '<li>12NG</li> '+
                            '<li>X2NG</li>'+
                        '</ul>'+
                    '</div> '+
                    '<div class="games-table-header games-table-tree">'+
                        '<ul>'+
                            '<li>1X&GG</li> '+
                            '<li>12GG</li> '+
                            '<li>X2GG</li>'+
                        '</ul>'+
                    '</div>'+
                '</div>';

        return html;
  },
  gamesHtml: function (index, quotes) {
    let html =  '<div class="games-table-holder" data-id="'+quotes.ID+'" data-homeTeam="'+quotes.TeamNameHome+'" data-awayTeam="'+quotes.TeamNameAway+'">'+
                    '<div class="games-table games-table-title-long">'+
                        '<div class="game-number">'+index+'.</div> '+quotes.TeamNameHome+' - '+quotes.TeamNameAway + '<span class="more-games more-games-span" data-modal="' + quotes.ID + '" > + </span>' +
                        '</div> '+
                        '<div class="games-table games-table-tree">'+
                            '<ul>'+
                                '<li data-betType="1X&NG" data-betCode="191" class="bet-choose" data-odd="'+quotes.DC1X_NG+'">'+globalFunctions.checkQuotes(quotes.DC1X_NG)+'</li> '+
                                '<li data-betType="12&NG" data-betCode="192" class="bet-choose" data-odd="'+quotes.DC12_NG+'">'+globalFunctions.checkQuotes(quotes.DC12_NG)+'</li> '+
                                '<li data-betType="X2&NG" data-betCode="190" class="bet-choose" data-odd="'+quotes.DCX2_NG+'">'+globalFunctions.checkQuotes(quotes.DCX2_NG)+'</li>'+
                            '</ul>'+
                        '</div> '+
                        '<div class="games-table games-table-tree">'+
                            '<ul>'+
                                '<li data-betType="1X&GG" data-betCode="181" class="bet-choose" data-odd="'+quotes.DC1X_GG+'">'+globalFunctions.checkQuotes(quotes.DC1X_GG)+'</li> '+
                                '<li data-betType="12&GG" data-betCode="182" class="bet-choose" data-odd="'+quotes.DC12_GG+'">'+globalFunctions.checkQuotes(quotes.DC12_GG)+'</li> '+
                                '<li data-betType="X2&GG" data-betCode="180" class="bet-choose" data-odd="'+quotes.DCX2_GG+'">'+globalFunctions.checkQuotes(quotes.DCX2_GG)+'</li>'+
                            '</ul>'+
                        '</div>'+
               '</div>';

    return html;
  }
};



//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/js/modules/odds/dc_and_gg_ng.js
// module id = 2019
// module chunks = 4